import { PageMeta } from "@/components/common/PageMeta";
import { TerminalScene } from "@/components/404/TerminalScene";

export function NotFoundPage() {
  return (
    <>
      <PageMeta
        title="404 | COSX"
        description="Page not found."
        path="/404"
        noindex
      />

      <div className="relative z-10 min-h-screen flex items-center justify-center pt-[var(--topnav-height)] px-8 pb-24">
        <TerminalScene />
      </div>
    </>
  );
}
